import AccessibilityFeaturesComponent from "../../../../components/partner/Settings/accessibility-features/accessibility-features";

export default function AccessibilityFeatures() {
  return <AccessibilityFeaturesComponent />;
}
